<template>
  <v-container class="mt-2 mr-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card-title primary-title>
          <v-spacer></v-spacer>
          <v-dialog v-model="dialog" max-width="500px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
                tile
                small
              >
                <v-icon>mdi-plus</v-icon>
              </v-btn>
            </template>
            <v-card>
              <v-card-title primary-title>
                Nueva categoría
              </v-card-title>
              <v-card-text>
                <v-text-field 
                  v-model="editedItem.nomcatego" 
                  label="Categoría" 
                  filled
                ></v-text-field>
              </v-card-text>

              <v-card-actions>
                <v-btn
                  color="black"
                  dark
                  small
                  @click="close"
                  tile
                  dense
                >
                  <v-icon left small>mdi-close</v-icon>
                  Cancelar
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary"
                  small
                  dark
                  @click="save"
                  tile
                >
                  <v-icon left small>mdi-content-save</v-icon>
                  Guardar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn  class="orange ml-2" small tile dark @click="initialize" ><v-icon>mdi-refresh</v-icon> </v-btn>

        </v-card-title>

        <v-card-text>
          <v-row justify="end">
            <v-col cols="12" md="6">
              <v-text-field
                dense
                filled
                single-line
                hide-details
                label="Búscar"
                v-model="search"
                append-icon="mdi-magnfy"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        
      </v-col>

      <!-- Catalago en forma de carts -->
      <v-col cols="12" md="6" lg="4" xl="3" v-for="(a, i) in filterArticulos" :key="i">
        <v-card class="ma-2 elevation-12">
          <v-row>
            <v-col cols="12">
              <v-card-text align="center" class="pb-0">
               <h2> <b>{{a.nomcatego}}</b><br/></h2>
              </v-card-text>
              <v-card-title primary-title>
                Detalles 
                <v-btn color="blue" icon 
                  @click="dialogDetalle = true, idSelectCatego = a.idcatego , metodoDescrip = 1"
                  >
                  <v-icon>mdi-plus-circle</v-icon>
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-data-table
                :loading="loading"
                :headers="headersArt"
                :items="a.descripcion"
                fixed-header
                :height="200"
                hide-default-footer
                loading-text="Cargando..."
                dense
                :items-per-page="100"
                :mobile-breakpoint="250"
                >
                <template v-slot:item.actions="{ item }">
                  <v-icon
                    color="blue"
                    small
                    class="mr-2"
                    @click="editDetalle(item), idSelectCatego = item.idcatego"
                  >
                    mdi-pencil
                  </v-icon>

                  <v-icon
                    color="red"
                    small
                    @click="dialog3 = true, idDeleteDescripcion = item.iddescripcion"
                  >
                    mdi-delete
                  </v-icon>

                </template>
                </v-card-title>
              </v-data-table>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" small dark @click="editItem(a)" rounded>Editar<v-icon right>mdi-pencil</v-icon></v-btn>
            <v-btn color="secondary" small @click="dialog2 = true, idDelete = a.idcatego" rounded>Eliminar<v-icon right>mdi-delete</v-icon></v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <!-- Eliminar una categoría -->
    <v-row justify="center">
      <v-dialog v-model="dialog2" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Categoría</v-card-title>
          <v-card-text>¿Al eliminar la categoría, eliminar también las descripciones?</v-card-text>
          <v-card-actions>
            <v-btn
              color="black"
              dark
              small
              @click="dialog2 = false"
              tile
              dense
            >
              <v-icon left small>mdi-close</v-icon>
              Cancelar
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              small
              dark
              @click="deleteItem"
              tile
            >
              <v-icon left small>mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Editar detalle -->
    <v-row justify="center">
      <v-dialog v-model="dialogDetalle" max-width="350px">
        <v-card>
          <v-card-title class="subtitle-1">
            Agregar Detalle
          </v-card-title>
          <v-card-text>
            <!-- return-object -->
            <v-text-field 
              v-model="editedDetalle.descripcion" 
              label="Descripción"
              filled
              dense
            ></v-text-field>
            <v-text-field 
              v-model="editedDetalle.precio" 
              label="Precio" 
              type="number"
              filled
              dense
            ></v-text-field>
            <v-select 
              :items="unidades"
              v-model="editedDetalle.unidad"
              item-text="unidad"
              item-value="idunidades" 
              label="Unidad"
              persistent-hint
              return-object
              filled
              dense
            ></v-select>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" rounded dark small @click="dialogDetalle=false">Cancelar</v-btn>
            <v-btn color="blue darken-1" rounded dark small @click="saveDetalle">Guardar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Elimnar un detalle -->
    <v-row justify="center">
      <v-dialog v-model="dialog3" persistent max-width="350">
        <v-card>
          <v-card-title class="headline">Eliminar Detalle</v-card-title>
          <v-card-text>¿Deseas eliminar permanentemente el detalle?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" text @click="dialog3 = false">Cancelar</v-btn>
            <v-btn color="green darken-1" text @click="deleteDetalle">Aceptar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>

<script>

  import {mapActions, mapGetters} from 'vuex'

  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'

  export default {

    components:{
      Alerta,
      carga,
    },

    mixins:[ validarErrores ],

    data: () => ({

      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      dialogDetalle: false,
      idSelectCatego:0,
      idDeleteDescripcion:'',
      metodoDescrip: 0,


      idCatego:0,
      mensaje:'',
      dialog3: false,
      dialog4:false,
      loading:true,
      idDelete: 0,
      idSelectArt:0,
      dialog2: false,


      loading:true,
      idDelete: 0,
      dialog: false,
      dialog2: false,
      headersArt: [
        { text: 'Detalle',  align: 'start', value: 'descripcion'},
        { text: 'Unidad',   align: 'start', value: 'unidad'},
        { text: 'Precio',   align: 'start', value: 'precio'},
        { text: 'Acciones', align: 'start', value: 'actions'},
      ],
      desserts: [],
      editedIndex: -1,
      editedItem: {
        idcatego: 0,
        nomcatego:''
      },

      editedDetalle: {
        iddescripcion:0,
        idcatego: 0,
        descripcion: '',
        precio: 0.00,
        unidad:'PZA',
        idunidades:0,
        factor:1,
      },


      defaultItem: {
        iddescripcion: 0,
        precio: 0,
        descripcion: '',
      },
      search:'',
      longitud: 100,


      // Unidades
      unidades:[],
    }),

    watch: {
      dialog (val) {
        val || this.close()
      },
    },

    created () {
      this.initialize()
      this.getClasificacion()
      this.getArticulos()
    },

    methods: {
      initialize () {
        this.cargar = true
        this.unidades = []
        this.$http.get('unidades.all').then(response=>{
          this.unidades = response.body
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getClasificacion () {
        this.$http.get('clasificacion.all').then(response=>{
          this.desserts = response.body
          this.longitud = this.desserts.length
          this.loading = false
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getArticulos () {
        this.cargar = true
        this.articulos = []
        this.$http.get('articulos.all').then(response=>{
          this.articulos = response.body
          this.cargar = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      editItem (item) {
        this.editedIndex = this.desserts.indexOf(item)
        this.editedItem = Object.assign({}, item)
        this.dialog = true
      },

      deleteItem () {
        this.$http.delete('clasificacion.delete/' + this.idDelete).then(response=>{
          this.initialize()
          this.cargar = false
          this.dialog2 = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      close () {
        this.dialog = false
        this.$nextTick(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        })
      },

      save () {
        if (this.editedIndex > -1) {
          this.$http.put('clasificacion.update/' + this.editedItem.idcatego, this.editedItem).then(response=>{
           this.cargar = false
            this.close()
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
          // Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.$http.post('clasificacion.add',this.editedItem).then(response=>{
            this.cargar = false
            this.close()
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
      },

      saveDetalle(){
        this.editedDetalle.idcatego = this.idSelectCatego
        this.editedDetalle.idunidades = this.editedDetalle.unidad.idunidades
        if (this.metodoDescrip == 2) {
          this.$http.put('descripcion.update/' + this.editedDetalle.iddescripcion, this.editedDetalle).then(response=>{
            this.cargar = false
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
          // Object.assign(this.desserts[this.editedIndex], this.editedItem)
        } else {
          this.$http.post('descripcion.add',this.editedDetalle).then(response=>{
            this.cargar = false
            this.initialize()
          }).catch( error =>{
            this.validarError( error )
          }).finally( () => { this.cargar = false })
        }
        this.editedDetalle.descripcion = ''
        this.editedDetalle.precio = 0
        this.dialogDetalle = false
        this.metodoDescrip = 0
      },

      editDetalle(value){
        console.log(value)
        // this.editedDetalleindex = this.desserts.indexOf(item)
        this.editedDetalle = Object.assign({}, value)
        this.editedDetalle.unidad = {idunidades:this.editedDetalle.idunidades , unidad: this.editedDetalle.unidad}
        this.dialogDetalle = true
        this.metodoDescrip = 2
      },

      deleteDetalle(){
        this.$http.delete('descripcion.delete/' + this.idDeleteDescripcion).then(response=>{
          this.cargar = false
          this.initialize()
          this.dialog3 = false
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

    },

    computed:{
      filterArticulos: function(){
        var me = this
        if(this.desserts){
          return this.desserts.filter((art)=>{
            var nom = art.nomcatego.toLowerCase();
            return nom.match(this.search.toLowerCase());
          })
        }
      },
    }
  }
</script>
